/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DetailExerciseDocumentSchema } from '../models/DetailExerciseDocumentSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExercisesDocumentsApi {
    /**
     * Patch Exercise Document Api
     * Patch exercise document.<br>Required permission: edit_exercises
     * @returns DetailExerciseDocumentSchema OK
     * @throws ApiError
     */
    public static exercisesDocumentsPatchExerciseDocumentApiPatch({
        exerciseDocumentId,
    }: {
        exerciseDocumentId: string,
    }): CancelablePromise<DetailExerciseDocumentSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/exercises-documents/{exercise_document_id}/',
            path: {
                'exercise_document_id': exerciseDocumentId,
            },
        });
    }
}
